(function() {
    "use strict";

    angular.module("gardaSee")
        .directive("showMore", [
            function() {
                return {
                    restrict: "A",
                    link: function($scope, $element, $attr, $controller) {
                        var colapsableContainer = angular.element($attr.showMore);
                        var moreText = $attr.more;
                        var lessText = $attr.less;

                        $element.html(colapsableContainer.hasClass('open') ? lessText : moreText);

                        $element.bind("click", function() {
                            colapsableContainer.toggleClass('open');
                            var isOpen = colapsableContainer.hasClass('open');
                            $element.html(isOpen ? lessText : moreText);
                        });
                    }
                }
            }
        ])
        .directive("fontHeight", [
            function() {
                return {
                    link: function ($scope, $element) {
                        var oldHeight = 0;

                        requestAnimationFrame(function updateHeight() {
                            var height = $element.height();
                            if (height !== oldHeight) {
                                oldHeight = height;
                                $element.css({
                                    'font-size': (height * 0.9) + "px",
                                    'line-height': height + "px"
                                });
                            }
                            requestAnimationFrame(updateHeight);
                        });
                    }
                }
            }
        ])
        .directive("collaps", [
            "cookie", "$window",
            function (cookie, $window) {
                return {
                    restrict: "A",
                    link: function ($scope, $element, $attr, $controller) {
                        var colapsableContainer = $element.parent().next();

                        var collaps = function () {
                            if (colapsableContainer.hasClass("js-collapsed")) {
                                colapsableContainer.addClass("animate");
                                $element.addClass("show");
                                colapsableContainer.slideDown(300, function () { colapsableContainer.removeClass("animate").removeClass("js-collapsed"); });
                            } else {
                                colapsableContainer.addClass("animate");
                                $element.removeClass("show");
                                colapsableContainer.slideUp(300, function () { colapsableContainer.removeClass("animate").addClass("js-collapsed"); });
                            }
                        }

                        $element.bind("click", collaps);
                        $element.parent().bind("click", collaps);
                    }
                }
            }
        ])
        //.directive("heroFixed", [
        //    "$window",
        //    function ($window) {
        //        return {
        //            link: function ($scope, $element, $attr) {

        //                var body = angular.element($window);
        //                var scrollTopOld = 0;
        //                var isScrollTopInit = false;
        //                body.bind("scroll", function () {
        //                    if (!isScrollTopInit) {
        //                        scrollTopOld = body.scrollTop();
        //                        isScrollTopInit = true;
        //                    }

        //                    if (body.scrollTop() > scrollTopOld + 10) {
        //                        $element.addClass("slide-up");
        //                    } else if (body.scrollTop() < scrollTopOld) {
        //                        $element.removeClass("slide-up");
        //                    }
        //                    scrollTopOld = body.scrollTop();
        //                });

        //            }
        //        }
        //    }
        //])
        .directive("mobileNavbar", [
            "$window",
            function ($window) {
                return {
                    link: function ($scope, $element, $attr) {
                        var offset = $element.offset().top;
                        var parent = $element.parent();
                        var prevOrigMargin = +parent.css("padding-top").replace("px", "") || 0;

                        var navbar = $('.topmenu'); // <== hack!! because navbar can change size.
                        var enquirybar = $('.enquirybar');
                        var getTop = function() { // <== hack!! on tabled make filterbar sticky under enquirybar
                            var t = navbar.height();
                            if (enquirybar.css('position') == 'fixed') {
                                t += enquirybar.height();
                            }
                            return t;
                        };

                        var body = angular.element($window);
                        body.bind("scroll", function() {
                            if (offset - body.scrollTop() <= 0) {
                                $element.addClass("fixed").css('top', getTop());
                                if ($element.css('position') == 'fixed') {
                                    parent.css("padding-top", prevOrigMargin + $element.height() + "px");
                                }
                            } else {
                                $element.removeClass("fixed");
                                parent.css("padding-top", prevOrigMargin + "px");
                            }
                        });
                    }
                }
            }
        ]);

})();